import { motion } from 'framer-motion'
import styled from 'styled-components'
import { mediaMax } from '../../../constants/breakpoints'

interface RoomSide {
  background?: string
}

export const RoomSide = styled(motion.div)<RoomSide>`
  position: absolute;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transform-style: preserve-3d;

  ${({ background }) => (background ? `background: ${background};` : '')};

  &.left,
  &.right {
    width: 4000px; /* depth */
    height: 100vh;

    @media ${mediaMax.mobileL} {
      width: 1000px;
    }
  }

  &.back {
    width: 100vw;
    height: 100vh;
    /* Original: 4000.  Use 4000 - 20. And 1000 in mobile. */
    transform: translate3d(0, 0, -3980px) rotate3d(1, 0, 0, 0.1deg) rotate3d(1, 0, 0, 0deg);

    @media ${mediaMax.mobileL} {
      transform: translate3d(0, 0, -980px) rotate3d(1, 0, 0, 0.1deg) rotate3d(1, 0, 0, 0deg);
      width: 100%;
      height: 100%;
    }
  }

  &.right {
    right: 0;
    top: 0;
    transform: rotate3d(0, 1, 0, -90deg);
    transform-origin: 100% 50%;
  }

  &.left {
    justify-content: flex-start;
    transform: rotate3d(0, 1, 0, 90deg);
    transform-origin: 0 50%;
  }

  &.bottom {
    width: 100vw; /* depth */
    height: 4000px;
    transform: rotate3d(1, 0, 0, 90deg) translate3d(0, -4000px, 0);
    transform-origin: 50% 0%;
    top: 100%;
    overflow: hidden;

    @media ${mediaMax.mobileL} {
      width: 100%;
      height: 1000px;
      transform: rotate3d(1, 0, 0, 90deg) translate3d(0, -1000px, 0);
    }
  }

  &.top {
    width: 100vw; /* depth */
    height: 4000px;
    transform: rotate3d(1, 0, 0, 90deg) translate3d(0, -4000px, 0);
    transform-origin: 50% 0%;
    top: 0;

    @media ${mediaMax.mobileL} {
      width: 100%;
      height: 1000px;
      transform: rotate3d(1, 0, 0, 90deg) translate3d(0, -1000px, 0);
    }

    /* background: linear-gradient(124.88deg, #0096D6 0%, rgba(0,0,0,0) 100%); */
    /* background-color: black; */
  }
`

export default RoomSide
